import { call, delay, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadVehicleTripsFailed, loadVehicleTripsSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadVehicleTrips(action) {
  try {
    const { payload = {} } = action;
    const { filter } = payload;
    const url = `${BACKEND_URL_V2}/info/locations/search`;
    const pool = {};
    pool.filter = addFilterQuery(filter);

    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadVehicleTripsSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadVehicleTripsFailed(data));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadVehicleTripsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
